
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120 120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"icon-fill-color",attrs:{"cx":"60","cy":"60","r":"60","fill":"#80A53F"}}),_c('g',{attrs:{"filter":"url(#filter0_d_421_286)"}},[_c('path',{attrs:{"d":"M88.966 35.172H31.035a4.138 4.138 0 00-4.138 4.138v41.38a4.138 4.138 0 004.138 4.138h57.93a4.138 4.138 0 004.138-4.138V39.31a4.138 4.138 0 00-4.137-4.138zM85.779 80.69H34.47l14.483-14.98-2.98-2.875L31.034 78.29V42.455l25.718 25.593a4.138 4.138 0 005.834 0l26.38-26.234V78.02L73.738 62.793l-2.917 2.917 14.958 14.98zM33.745 39.31h51.869l-25.945 25.8-25.924-25.8z","fill":"#fff"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_421_286","x":"22.897","y":"33.172","width":"74.207","height":"57.655","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_421_286"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_421_286","result":"shape"}})])])])
          )
        }
      }
    